export default [
	'STRIVE',
	'External',
	'HSC'
];